// PROLINE-3755: the API only has "approved" / "pending" company statuses —
// there is no "Suspended" status, so the original Active(green)/Suspended(red)
// design doesn't apply. Approved keeps the green (still "the good outcome");
// Pending reads as awaiting/neutral rather than a problem, so it's amber, not red.
export const STATUS_COLOR = {
  approved: "var(--color-success-600, #15803D)",
  pending: "var(--color-warning-500, #F59E0B)",
};
